// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkCard-cls1_hp_","cls2":"WorkCard-cls2_m5U WorkCard-cls1_hp_"};